import { useCallback } from "react";
import { MolstarWrapper } from "@loschmidt/molstar";
import { isEmptyLoci } from 'molstar/lib/mol-model/loci';
import { createResidueLociGetter } from "./residue-loci-getter";

export function useFocusResidue(
  viewer: MolstarWrapper | undefined,
  proteinModel: string | undefined,
) {
  return useCallback((chain: string, position: number) => {
    if (!viewer || !proteinModel) return;
    const structureData =
      viewer.plugin.managers.structure.hierarchy.current.structures.find(
        s => s.cell.sourceRef === proteinModel
      );
    if (!structureData) return;
    const lociGetter = createResidueLociGetter(chain, [position]);
    lociGetter(structureData.cell.obj!.data).then(loci => {
      if (!isEmptyLoci(loci)) {
        viewer.plugin.managers.camera.focusLoci(loci);
      }
    })
  }, [viewer, proteinModel]);
}
